import {
  useFormGroup
} from "../__chunks/LOJQ7RPL.js";
import "../__chunks/2NIRKFVH.js";
import "../__chunks/F5VAC7MB.js";
import {
  createComponent,
  createElement,
  createHook
} from "../__chunks/NQJBHION.js";
import "../__chunks/J7Q2EO23.js";
import "../__chunks/CP3U4HPL.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/PNRLI7OV.js";

// src/form/form-radio-group.ts
var useFormRadioGroup = createHook(
  (_a) => {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    props = __spreadValues({ role: "radiogroup" }, props);
    props = useFormGroup(props);
    return props;
  }
);
var FormRadioGroup = createComponent(
  (props) => {
    const htmlProps = useFormRadioGroup(props);
    return createElement("div", htmlProps);
  }
);
if (process.env.NODE_ENV !== "production") {
  FormRadioGroup.displayName = "FormRadioGroup";
}
export {
  FormRadioGroup,
  useFormRadioGroup
};
